import { INotification } from '../Interfaces/NotificationPageInterfaces';
export const ADD_NEW_CONFIGURATION_ID = 'ADD_NEW_CONFIGURATION_ID';
export const getNotificationTypes = (notification: INotification, t: any): string[] => {
    const baseTypes = notification.alertsConsole ? [t('TYPES.CONSOLE')] : [];
    const integrationTypes = notification?.integrations?.map((integration) => integration.type) || [];
    return [...integrationTypes, ...baseTypes];
};
